import React from "react";
import EditProfileList from "../EditProfile/EditProfileList";


const EditProfileComponent = () => {
    return(
        <>
            <EditProfileList/>
        </>
    );
}
export default EditProfileComponent;